/*
 * Copyright (c) 2024-2025. Bolmate B.V.
 */

import './style/bolmatePlaceholderOverlay.scss';
import React from 'react';
import Image from "./image";
import classNames from 'classnames';

interface Props {
    className?: string;
}

export default function BolmatePlaceholderOverlay({className}: Props) {
    return (
        <div className={classNames('bolmate-placeholder-overlay', className)}>
            <Image name='logo-no-text-gray' alt='Bolmate' className='loading-logo'
                   style={{maxHeight: '25%', minHeight: '4rem'}}/>
        </div>
    )
}